<template>
    <div class="flex-grow-1">
        <div class="app-academy">
            <course-search-component :route="'search-user-courses'" :method="showResults" :pagination="true" :query="'user-courses'"></course-search-component>

          <div class="card mb-4">
            <div class="card-header d-flex flex-wrap justify-content-between gap-3">
            <div class="card-title mb-4 me-1 text-md-center" style="width: 100%;">
                <h5 class="mb-1">All Your Courses</h5>
                <p class="text-muted mb-0">Your Credit Education Journey Begins Here</p>
              </div>
            </div>


            <div class="card-body">
              <div class="row gy-4 mb-4">

                <div class="col-sm-6 col-lg-3" v-for="(course, index) in courses"  :key="index" v-if="courses.length > 0">
                  <div class="card p-2 shadow-none border">
                    <div class="rounded-2 text-center mb-3">
                        <div class="rounded-2 text-center">
                            <router-link :to="{ name: 'courses-content',params:{course:course.slug}}">
                                <img class="img-fluid" :src="course.image_url" alt="tutor image 1">
                            </router-link>
                        </div>
                    </div>

                    <div class="card-body p-3 pt-2">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <span class="badge bg-label-primary">{{course.category}}</span>
                            <h6 class="d-flex align-items-center justify-content-center gap-1 mb-0">
                            {{ avarage(course.avarage_rating.total_rating,course.avarage_rating.number_of_rating)}}
                            <star-rating  :rating="avarage(course.avarage_rating.total_rating,course.avarage_rating.number_of_rating)"  :totalStars= "1" :size="18" :disabled="true"/>
                            <span class="text-muted">({{ formatNumber(course.rating_count) }})</span>
                            </h6>
                        </div>
                         <router-link
                            :to="{ name: 'courses-content',params:{course:course.slug}}" class="h5">{{course.title}}
                        </router-link>
                        <p class="my-1">Instructor :
                            <span class="" v-if="course.instructor_name"> {{course.instructor_name}}</span>
                            <span class="" v-else> {{course.author_name}}</span>
                        </p>
                      <p class="d-flex align-items-center">Watch Time: {{ convertSecToTime(course.user_watch_time) }}</p>
                      <div class="progress mb-4" style="height: 8px">
                        <div class="progress-bar" role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" :style="{ width: courseProgress(course.user_watch_time,course.total_hours) + '%' }" ></div>
                      </div>
                      <div class="d-flex flex-column flex-md-row gap-2 text-nowrap">
                        <router-link
                        :to="{ name: 'courses-content',params:{course:course.slug}}" class="app-academy-md-50 btn btn-label-secondary me-md-2 d-flex align-items-center waves-effect">
                            <vue-feather type="rotate-ccw" size="18" class="mr-1"></vue-feather>
                            <span>Start Over</span>
                        </router-link>
                        <router-link
                            :to="{ name: 'courses-content',params:{course:course.slug}}" class="app-academy-md-50 btn btn-outline-secondary d-flex align-items-center waves-effect">
                            <vue-feather type="eye" size="18" class="mr-1"></vue-feather>
                            <span>Continue</span>
                        </router-link>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              <nav aria-label="Page navigation" class="d-flex align-items-center justify-content-center">
                <div v-if="containPagination == true">
                    <div class="my-2 d-flex justify-content-center" v-if="courses.length">
                        <pagination v-model="currentPage" :records="rows" :per-page="perPage" @paginate="getCourses"/>
                    </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
</template>
<script>
import {ref,reactive} from 'vue'

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import CourseSearchComponent from './layouts/CourseSearchComponent.vue';
import {convertSecToTime,formatNumber,avarage} from '../../../utilities/_helpers'
export default {
    components:{
        vSelect,
        CourseSearchComponent
    },
    setup(){
        const options= [
            'All Courses','UI/UX','SEO','Web','Music','Painting'
        ];
        return{
            selectedOption:ref(),
            ContentisLoading:ref(true),
            courses:ref(true),
            convertSecToTime:convertSecToTime,
            formatNumber:formatNumber,
            containPagination : ref(true),
            prevDataResult : ref({}),
            currentPage : ref(1),
            perPage : ref(),
            prevPage : ref(),
            nextPage : ref(),
            rows : ref(),
            limit:ref(8),
            options,
            avarage:avarage,
            _: _,
        }
    },
    mounted(){
        this.getCourses(1)
    },
    created() {
        if (this.$route.name == 'user-courses') {
            const link = document.createElement('link')
            link.rel = 'stylesheet'
            link.type = 'text/css'
            link.href = '/css/education.css'
            document.head.appendChild(link)
        }
    },
    destroyed() {
        document.documentElement.classList.remove('core-css-class')

        const existingLink = document.querySelector('link[href="/css/education.css"]')
        if (existingLink) {
            existingLink.parentNode.removeChild(existingLink)
        }
    },
    methods:{
        showResults(result,pagination){
            if(result.data == undefined){
                this.getCourses()
                this.containPagination = true
            }else{
                if(result.data.data.length <= 0 ){
                    toastr.error('No Result Found','Search')
                    this.getCourses()
                    this.containPagination = true
                }else{
                    let $this = this;
                    let dataCurrent = result.data;
                    $this.courses = dataCurrent.data
                    $this.prevDataResult = dataCurrent.data
                    $this.ContentisLoading =false;
                    $this.containPagination = pagination
                    $this.rows = dataCurrent.total
                }
            }

        },
        getCourses(page){
            if(typeof page == null || typeof page == undefined){
                page = 1
            }
            const $this =this;
            const route = this.$router.resolve({
                name:'user-courses',

            });
            axios.post(`${route.href}?page=${+page}&limit=${this.limit}&type=user-courses`).then(({ data }) => {
                let dataCurrent = data.data;
                $this.courses = dataCurrent.data
                $this.prevDataResult = dataCurrent.data
                $this.ContentisLoading =false;

                $this.currentPage = dataCurrent.current_page
                $this.perPage = dataCurrent.per_page
                $this.prevPage = dataCurrent.prev_page_url
                $this.nextPage = dataCurrent.next_page_url
                $this.rows = dataCurrent.total

            })
            .catch(function (error) {
                console.log(error);
            });
        },
        courseProgress(userWatchTime,totalHours) {
            const percentage = (userWatchTime / totalHours) * 100;
            return Math.round(percentage);
        }
    }
}
</script>
